<template>
  <transition name="fade">
    <wds-button-icon
      v-if="isSideBarOpenDesktop"
      class="sidebar-toggle-button"
      sm
      @click="toggleSidebar"
    >
      <template #default>
        <wds-icon :size="16" name="exit"></wds-icon>
      </template>
    </wds-button-icon>
  </transition>
</template>

<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { WdsButtonIcon, WdsIcon } from '@worksome/wds-components'
import { APP_NAVIGATION } from '@/state/mutation-types'

const store = useStore()
const isSideBarOpenDesktop = computed(() => store.state.navigation.isSideBarOpenDesktop)

const toggleSidebar = () => {
  store.commit(APP_NAVIGATION.TOGGLE_DESKTOP_SIDEBAR_OPEN_STATE)
}
</script>

<style scoped>
.sidebar-toggle-button {
  @apply tw-ps-3;
}

:deep(.wds-button-icon) {
  background-color: transparent;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

@media (max-width: 1279px) {
  .sidebar-toggle-button {
    display: none;
  }
}
</style>
